/**
 * App configuration.
 *
 * shellDefault: Whether routes show the shell (tabs, sidebar, chat) by default.
 * Override per-request with ?shell=true or ?shell=false query param.
 * Shell always requires authentication regardless of route's publicRoute setting.
 */
export const appConfig = {
  shellDefault: true,
};
